import { createBrowserHistory, createHashHistory, createMemoryHistory } from '@umijs/runtime';
import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import qs from 'qs';

const type = "browser";
export const history = type === 'hash'
  ? createHashHistory()
  : type === 'memory'
  ? createMemoryHistory()
  : createBrowserHistory();

export const useParams = ReactRouterDOM.useParams;
export const useRouteMatch = ReactRouterDOM.useRouteMatch;
export const useHistory = ReactRouterDOM.useHistory;
export const matchPath = ReactRouterDOM.matchPath;

/** Umi3-compatible: location.query always present */
export function useLocation() {
  const location = ReactRouterDOM.useLocation();
  if (location && !location.query) {
    location.query = qs.parse((location.search || '').replace(/^\?/, '')) || {};
  }
  return location;
}

export function Link(props) {
  return React.createElement(ReactRouterDOM.Link, props);
}

export function NavLink(props) {
  return React.createElement(ReactRouterDOM.NavLink, props);
}

/** Umi3-compatible: dynamic(loader) | dynamic(loader, opts) | dynamic({ loader, loading }) */
export function dynamic(loaderOrOpts, options = {}) {
  let loader;
  let loading;
  if (typeof loaderOrOpts === 'function') {
    loader = loaderOrOpts;
    loading = options.loading || (() => null);
  } else if (loaderOrOpts && typeof loaderOrOpts === 'object') {
    loader = loaderOrOpts.loader;
    loading = loaderOrOpts.loading || (() => null);
  } else {
    throw new Error('[umi] dynamic() expects a loader function or options object');
  }
  let Component = null;
  return function DynamicComponent(props) {
    const [comp, setComp] = React.useState(Component);
    React.useEffect(() => {
      let mounted = true;
      Promise.resolve(typeof loader === 'function' ? loader() : loader).then((mod) => {
        const C = mod.default || mod;
        Component = C;
        if (mounted) setComp(() => C);
      });
      return () => { mounted = false; };
    }, []);
    if (!comp) {
      return typeof loading === 'function'
        ? React.createElement(loading, props)
        : loading || null;
    }
    return React.createElement(comp, props);
  };
}
